






















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

type Size = 'small' | 'medium' | 'large';

interface InputConfig {
  name: string,
  size?: Size,
  disabled?: boolean,
  placeholder?: string
  label?: string,
  key?: string,
  inline?: boolean,
  tip?: string,
  validators?: any,
  prepend?: string,
  append?: string,
  suffix?: string,
  type?: string
}

@Component({
  name: 'mcSearchInput'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private value!: any;
  @Prop({ default: () => [] }) private config!: InputConfig;
  private currentValue: string = this.value || '';
  private defaultConfig: any = {
    size: 'medium',
    placeholder: '请输入',
    clearable: true
  };

  // 检测值
  @Watch("value")
  onValueChanged(val: string) {
    this.currentValue = val;
  }

  // 清除事件
  @Emit('on-change')
  clearValue() {
    this.currentValue = '';
    this.$emit('input', '');
  }

  // 合并默认数据
  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  /**
   * 输入框值改变
   * @author tanxj
   * @param value 值
   */
  @Emit('on-change')
  handleChange(value: string) {
    this.$emit('input', value);
  }

  /**
   * 失去焦点事件
   * @author tanxj
   * @param any event 事件
   */
  handleBlur(event: any) {
    this.$emit('on-blur', event.target.value, event);
  }

  /**
   * 使input 获取焦点
   * @author tanxj
   * @param any event 事件
   */
  handleFocus(event: any) {
    this.$emit('on-focus', event);
  }

  /**
   * Enter事件
   * @author jie.shuai
   * @param any event 事件
   */
  @Emit('on-change')
  handleEnter(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit('input', event.target.value);
    return event.target.value;
  }
}
